import {
  Container,
  Heading,
  VStack,
  Box,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { useState, useRef } from "react";
import { FaPlay } from "react-icons/fa";

export default function Features() {
  const [isMainVideoPlaying, setIsMainVideoPlaying] = useState(false);
  const mainVideoRef = useRef<HTMLVideoElement>(null);

  const toggleMainVideoPlay = () => {
    if (mainVideoRef.current) {
      if (isMainVideoPlaying) {
        mainVideoRef.current.pause();
      } else {
        mainVideoRef.current.play();
      }
      setIsMainVideoPlaying(!isMainVideoPlaying);
    }
  };

  return (
    <Container maxW={"7xl"} px={{ base: 4, md: 8 }} id="features">
      <VStack spacing={12} width="100%" py={{ base: 8, md: 16 }}>
        {/* Tab tab tab with Sweep Section */}
        <VStack spacing={6} width="100%">
          <Heading
            fontSize={{ base: "2xl", md: "3xl" }}
            textAlign="center"
            color="white"
          >
            Tab Tab Tab in JetBrains
          </Heading>
          <Box maxW="container.xl" mx="auto" position="relative">
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: '100%',
                maxWidth: '1000px',
                borderRadius: '12px',
                margin: '0 auto',
                display: 'block',
              }}
            >
              <source src="/NEA_tab_tab_tab.mp4" type="video/mp4" />
            </video>
          </Box>
          <Text mt={6} maxW="container.xl" textAlign="center" fontSize="lg">
             Sweep's next-edit autocomplete uses your previous changes to suggest changes <br/>anywhere in your code. Just hit tab.
          </Text>
        </VStack>

        {/* Context-Aware Chat Section */}
        <VStack spacing={6} width="100%">
          <Heading
            fontSize={{ base: "2xl", md: "3xl" }}
            textAlign="center"
            color="white"
          >
            AI Agent built for JetBrains
          </Heading>
          <Box maxW="container.xl" mx="auto" position="relative">
            <video
              ref={mainVideoRef}
              loop
              muted
              playsInline
              autoPlay
              controls
              style={{
                width: '100%',
                maxWidth: '1000px',
                borderRadius: '12px',
                margin: '0 auto',
              }}
              onPlay={() => setIsMainVideoPlaying(true)}
              onPause={() => setIsMainVideoPlaying(false)}
            >
              <source src="/Sweep_Agent.mp4" type="video/mp4" />
              <img
                src="/sweep_ai_demo_screenshot.png"
                alt="Sweep AI Demo"
                style={{
                  width: '100%',
                  maxWidth: '1000px',
                  borderRadius: '12px',
                  margin: '0 auto',
                }}
              />
            </video>
            {!isMainVideoPlaying && (
              <IconButton
                aria-label="Play video"
                icon={<FaPlay />}
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                size="lg"
                fontSize="24px"
                color="white"
                bg="blackAlpha.600"
                _hover={{ bg: "blackAlpha.800" }}
                onClick={toggleMainVideoPlay}
                isRound
              />
            )}
          </Box>
          <Text mt={6} textAlign="center" fontSize="lg">
            Ship 10x faster with an Sweep, an AI agent that understands your entire codebase,<br/>makes complex multi-file changes, runs tests, and catches errors directly in your IDE.
          </Text>
        </VStack>
      </VStack>
    </Container>
  );
}